import * as tslib_1 from "tslib";
import * as React from "react";
var matchWindowMedia = function (query) {
    if (typeof window === "object" && window.matchMedia) {
        return window.matchMedia(query).matches;
    }
    return false;
};
export function executeMediaQuery(queries) {
    var matches = {};
    Object
        .keys(queries)
        .forEach(function (media) {
        var query = queries[media];
        matches[media] = typeof query === "string" ? matchWindowMedia(query) : query;
    });
    return matches;
}
;
var Media = (function (_super) {
    tslib_1.__extends(Media, _super);
    function Media(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            matches: {},
            matchers: {},
            keys: [],
        };
        _this.updateMatches = function () { return (_this.setState(function (_a) {
            var keys = _a.keys, matchers = _a.matchers, matches = _a.matches;
            return ({
                matches: keys.reduce(function (acc, key) {
                    acc[key] = matchers[key].matches;
                    return acc;
                }, tslib_1.__assign({}, matches))
            });
        })); };
        if (typeof window !== "object" || !window.matchMedia)
            return _this;
        var queries = props.queries;
        var keys = Object.keys(queries);
        _this.state.keys = keys;
        Object
            .keys(queries)
            .forEach(function (media) {
            var query = queries[media];
            if (typeof query === "string") {
                _this.state.matches[media] = (_this.state.matchers[media] = window.matchMedia(query)).matches;
            }
            else {
                _this.state.matches[media] = query;
            }
        });
        return _this;
    }
    Media.prototype.componentDidMount = function () {
        var _this = this;
        var matchers = this.state.matchers;
        Object.keys(matchers).forEach(function (match) { return matchers[match].addListener(_this.updateMatches); });
    };
    Media.prototype.componentWillUnmount = function () {
        var _this = this;
        var matchers = this.state.matchers;
        Object.keys(matchers).forEach(function (match) { return matchers[match].removeListener(_this.updateMatches); });
    };
    Media.prototype.render = function () {
        var children = this.props.children;
        var matches = this.state.matches;
        return children(matches);
    };
    return Media;
}(React.Component));
export { Media };
